import flagsmith from "flagsmith";
import { FlagsmithProvider } from "flagsmith/react";
import * as React from "react";
import { useEffect, useState } from "react";
import { useProfile } from "../profileProvider/ProfileProvider";

// Initialises flagsmith in the project
export const FlagsmithProviderWrapper = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const { profile } = useProfile();
  const [isMounted, setIsMounted] = useState(false);
  const flagsmithApiKey = process.env.NEXT_PUBLIC_FLAGSMITH_CLIENT_API_KEY;

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const identity = profile?.sub;
  useEffect(() => {
    if (!isMounted || !flagsmithApiKey || !identity) return;

    // The SDK reads Provider options only on its first render. Initialise
    // separately so the provider can stay mounted while identity loads.
    void flagsmith.init({
      environmentID: flagsmithApiKey,
      identity,
      api: process.env.NEXT_PUBLIC_FLAGSMITH_API_URL,
      cacheFlags: true,
      cacheOptions: { ttl: 60 * 60 * 1000 }
    });
  }, [isMounted, flagsmithApiKey, identity]);

  return (
    <FlagsmithProvider flagsmith={flagsmith}>
      <>{children}</>
    </FlagsmithProvider>
  );
};
